import { render, staticRenderFns } from "./modalAsignar.vue?vue&type=template&id=7db6c172"
import script from "./modalAsignar.vue?vue&type=script&lang=js"
export * from "./modalAsignar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports